'use client';

import classNames from '@wilkins-software/classnames-tailwind-merge';
import { useNavigation } from './NavigationContext';

export function OpenMenuButton() {
  const { isMenuOpen, setIsMenuOpen } = useNavigation();

  return (
    <button
      type="button"
      id="primary-nav-open-menu-button"
      className="relative z-[70] ml-auto flex size-11 items-center justify-center rounded-full border border-black/10 bg-white/70 shadow-sm backdrop-blur-xl transition-colors hover:border-primary/30 hover:bg-white lg:hidden"
      onClick={() => setIsMenuOpen(!isMenuOpen)}
      aria-expanded={isMenuOpen}
      aria-controls="menu-collapse"
      aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
    >
      <span className="relative block size-5" aria-hidden>
        <span
          className={classNames(
            'absolute left-0 block h-0.5 w-5 origin-center rounded-full bg-slate-900 transition-all duration-300 ease-[cubic-bezier(0.16,1,0.3,1)]',
            isMenuOpen ? 'top-[9px] rotate-45' : 'top-1 rotate-0',
          )}
        />
        <span
          className={classNames(
            'absolute top-[9px] left-0 block h-0.5 w-5 rounded-full bg-slate-900 transition-all duration-300 ease-[cubic-bezier(0.16,1,0.3,1)]',
            isMenuOpen ? 'scale-x-0 opacity-0' : 'scale-x-100 opacity-100',
          )}
        />
        <span
          className={classNames(
            'absolute left-0 block h-0.5 w-5 origin-center rounded-full bg-slate-900 transition-all duration-300 ease-[cubic-bezier(0.16,1,0.3,1)]',
            isMenuOpen ? 'top-[9px] -rotate-45' : 'top-[15px] rotate-0',
          )}
        />
      </span>
    </button>
  );
}
